import React from 'react';
import { parseCurrencyTruncated } from '@upstart/harmony/lib/form-utils';
import {
  FinalFee,
  FinanceResponseData,
} from '@upstart/harmony/lib/legos/financingTypes';
import Input, { PriceInput } from '../../../../components/PencilEditor/Input';
import { SectionItem, SectionTitle, SubsectionItem } from './FormItems';

export function FeeItem(props: {
  title?: string;
  subtitle?: string;
  descriptionFieldName?: keyof FinalFee;
  description?: React.ReactElement;
  fee?: FinalFee;
  responseData?: FinanceResponseData;
  isValueDisabled?: boolean;
  onChange: (data: Partial<FinanceResponseData>) => void;
  maxlength?: number;
  required?: boolean;
  subsectionItem?: boolean;
}) {
  const { responseData, fee, subsectionItem } = props;

  const updateFeeList = (newData: Partial<FinalFee>) => {
    const newFeeList = [...(responseData?.finalizedFeeList ?? [])];
    const feeIndex = newFeeList.findIndex(f => f === fee);
    if (feeIndex >= 0) {
      newFeeList[feeIndex] = { ...newFeeList[feeIndex], ...newData };
    }
    return newFeeList;
  };

  let descriptionElement = null;

  if (props.description) {
    descriptionElement = props.description;
  } else if (props.descriptionFieldName) {
    descriptionElement = (
      <Input
        required={!!fee?.value}
        value={props.fee?.[props.descriptionFieldName]}
        maxLength={props.maxlength}
        placeholder="N/A"
        onChange={(val: string) =>
          props.onChange({
            finalizedFeeList: updateFeeList({
              [props.descriptionFieldName ?? '']: val,
            }),
          })
        }
      />
    );
  } else if (props.title) {
    descriptionElement = (
      <SectionTitle title={props.title} subtitle={props.subtitle} />
    );
  }

  const sectionItem = subsectionItem ? SubsectionItem : SectionItem;

  return React.createElement(sectionItem, {
    description: descriptionElement,
    value: (
      <PriceInput
        disabled={props.isValueDisabled}
        value={props.fee?.value}
        placeholder="N/A"
        onChange={val =>
          props.onChange({
            finalizedFeeList: updateFeeList({
              value: parseCurrencyTruncated(val),
            }),
          })
        }
        required={props.required}
      />
    ),
  });
}

export default FeeItem;
